export default __webpack_public_path__ + "static/avatar-mp-kayi-female-0-v2-detail-0ccadb82f8bf11777c0a96ad4971eb76.png";